import { useNavigate } from 'react-router-dom'
import { TextNorm } from '@/components/ui/Text'
import Button from '@/components/ui/Button/Button'
import css from './NotFoundPage.module.css'

const NotFoundPage = () => {
    const navigate = useNavigate()

    return (
        <div className={css.container} data-testid="not-found-page">
            <span className={css.code}>404</span>
            <h1 className={css.title}>Page not found</h1>
            <TextNorm className={css.text}>
                The page you&rsquo;re looking for doesn&rsquo;t exist or has moved.
            </TextNorm>
            <div className={css.action}>
                <Button title="Go home" type="black" size="medium" onClick={() => navigate('/', { replace: true })} />
            </div>
        </div>
    )
}

export default NotFoundPage
